import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import upload from './modules/upload'
import media from './modules/media'
import routes from '@/router'
import Router from 'vue-router'

Vue.use(Vuex, Router)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {

		user,
		auth,
		upload,
		media
		
	},
	strict: debug,
	mode: 'history',
	routes
})